import React from 'react';
// import { useState } from "react";
import { useMediaQuery } from 'react-responsive'
import './DataScience.css'
import userData from '../content/data.json'  // Adjust the path as needed

const DataScience = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 480px)' }); // Mobile: <= 480px
    const isTablet = useMediaQuery({ query: '(min-width: 481px) and (max-width: 960px)' }); // Tablet: 481–960px
    // const isDesktop = useMediaQuery({ query: '(min-width: 961px) and (max-width: 1823px)' }); // Desktop: 961–1823px
    const isDesktop = useMediaQuery({ query: '(min-width: 961px)' }); // Big screen: >= 1824px
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
    const data = userData['dataScience']

    return (
        <div>

            {
                isDesktop && <div>
                    <div className='desktop-header'>
                        <div className="head" dangerouslySetInnerHTML={{ __html: data[0] }} />
                            
                        <div>
                            <div className='desktop-h-l1'>{data[1]}</div>
                            <div className='desktop-h-l1-body'>
                                <div className='paragraph' dangerouslySetInnerHTML={{ __html: data[2] }} />
                                <div className='paragraph' dangerouslySetInnerHTML={{ __html: data[3] }} />
                                <div className='paragraph' dangerouslySetInnerHTML={{ __html: data[4] }} />
                            </div>
                        </div>
                        <div  dangerouslySetInnerHTML={{ __html: data[5] }} />
                        <div>
                            <div className='desktop-h-l1' dangerouslySetInnerHTML={{ __html: data[6] }} />
                            <div className='desktop-h-l1-body' dangerouslySetInnerHTML={{ __html: data[7] }} />
                            <div className='desktop-h-l1-body' dangerouslySetInnerHTML={{ __html: data[8] }} />
                            <div className='desktop-h-l1-body' dangerouslySetInnerHTML={{ __html: data[9] }} />
                            <div className='desktop-h-l1-body' dangerouslySetInnerHTML={{ __html: data[10] }} />
                            <div className='desktop-h-l1-body' dangerouslySetInnerHTML={{ __html: data[11] }} />
                        </div>
                    </div>
                    <div className='footer' dangerouslySetInnerHTML={{ __html: data[12] }} />
                </div>
            }


            {
                isTablet && <div>
                    <div className='tablet-header'>
                        <div className="head" dangerouslySetInnerHTML={{ __html: data[0] }} />
                            
                        <div>
                            <div className='tablet-h-l1'>{data[1]}</div>
                            <div className='tablet-h-l1-body'>
                                <div className='paragraph' dangerouslySetInnerHTML={{ __html: data[2] }} />
                                <div className='paragraph' dangerouslySetInnerHTML={{ __html: data[3] }} />
                                <div className='paragraph' dangerouslySetInnerHTML={{ __html: data[4] }} />
                            </div>
                        </div>
                        <div  dangerouslySetInnerHTML={{ __html: data[5] }} />
                        <div>
                            <div className='tablet-h-l1' dangerouslySetInnerHTML={{ __html: data[6] }} />
                            <div className='tablet-h-l1-body' dangerouslySetInnerHTML={{ __html: data[7] }} />
                            <div className='tablet-h-l1-body' dangerouslySetInnerHTML={{ __html: data[8] }} />
                            <div className='tablet-h-l1-body' dangerouslySetInnerHTML={{ __html: data[9] }} />
                            <div className='tablet-h-l1-body' dangerouslySetInnerHTML={{ __html: data[10] }} />
                            <div className='tablet-h-l1-body' dangerouslySetInnerHTML={{ __html: data[11] }} />
                        </div>
                    </div>
                    <div className='footer' dangerouslySetInnerHTML={{ __html: data[12] }} />
                </div>
            }


            {
                isMobile && <div>
                    <div className='mobile-header'>
                        <div className="head" dangerouslySetInnerHTML={{ __html: data[0] }} />
                            
                        <div>
                            <div className='mobile-h-l1'>{data[1]}</div>
                            <div className='mobile-h-l1-body'>
                                <div className='paragraph' dangerouslySetInnerHTML={{ __html: data[2] }} />
                                <div className='paragraph' dangerouslySetInnerHTML={{ __html: data[3] }} />
                                <div className='paragraph' dangerouslySetInnerHTML={{ __html: data[4] }} />
                            </div>
                        </div>
                        <div  dangerouslySetInnerHTML={{ __html: data[5] }} />
                        <div>
                            <div className='mobile-h-l1' dangerouslySetInnerHTML={{ __html: data[6] }} />
                            <div className='mobile-h-l1-body' dangerouslySetInnerHTML={{ __html: data[7] }} />
                            <div className='mobile-h-l1-body' dangerouslySetInnerHTML={{ __html: data[8] }} />
                            <div className='mobile-h-l1-body' dangerouslySetInnerHTML={{ __html: data[9] }} />
                            <div className='mobile-h-l1-body' dangerouslySetInnerHTML={{ __html: data[10] }} />
                            <div className='mobile-h-l1-body' dangerouslySetInnerHTML={{ __html: data[11] }} />
                        </div>
                    </div>
                    <div className='footer' dangerouslySetInnerHTML={{ __html: data[12] }} />
                </div>
            }


        <div>
            {isTablet && <p>You are using a <strong>Tablet</strong></p>}
            {isMobile && <p>You are using a <strong>Mobile</strong> device</p>}
            {isDesktop && <p>You are on a <strong>Desktop</strong></p>}
            {/* {isBigScreen && <p>You have a <strong>Big Screen</strong></p>} */}
        </div>
    </div>

    )



};

export default DataScience;
